import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-41b6e3d3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "info" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "code" }, "HKD", -1))
const _hoisted_4 = { class: "detail" }
const _hoisted_5 = { class: "detail-time" }
const _hoisted_6 = { class: "detail-time-label" }
const _hoisted_7 = { class: "detail-time-value" }
const _hoisted_8 = { class: "detail-tips" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.awardName), 1),
      _createElementVNode("p", null, [
        _hoisted_3,
        _createElementVNode("span", null, _toDisplayString(_ctx.money || _ctx.configMoney), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('领取时间')), 1),
        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.dayjs(Number(_ctx.createTime)).format('YYYY-MM-DD HH:mm:ss')), 1)
      ]),
      _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.detail.receiveInfo), 1)
    ])
  ]))
}